import styled from 'styled-components';

export const StyledSelectDropdown = styled.select`
  border: 1px solid #ccc;
  border-radius: ${(props) => props.theme.radius.sm};
  font-size: 1rem;
  width: 100%;
  transition: all 0.4s;
  padding: 0.8rem 2rem 0.8rem 1rem;
  background-color: transparent;
  color: ${({ theme }) => theme.color.bodyTextColor};
  -webkit-text-fill-color: ${({ theme }) => theme.color.bodyTextColor};
  background: url('/caret-down.svg') no-repeat right;
  background-size: 14px;
  background-position: calc(100% - 10px) center;

  &:focus {
    outline-color: ${({ theme }) => theme.color.primary};
  }
`;
